import styled from 'styled-components';

export const Content = styled.input`
  font-family: monospace;
  width: ${(props) => props.width};
  text-align: center;
  font-size: 13px;
  line-height: normal;
  border: 0;
  border-left: 1px solid #ccc;
  height: 30px;
`;
